import { Component, inject, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { ModalComponent } from '../primeng/modal/modal.component';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss',
})
export class LoginModalComponent {
  private keycloak = inject(KeycloakService);
  
  @Input() visible: boolean = true;
  @Output() visibleChange = new EventEmitter<boolean>();

  onLogin(): void {
    // Redirect to Keycloak login page
    this.keycloak.login({
      redirectUri: window.location.href
    });
  }

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
